// extracted by mini-css-extract-plugin
module.exports = {"projects":"index-module--projects--27T_h","title":"index-module--title--1LAhw","project":"index-module--project--2Ola2","imageCount":"index-module--imageCount--Xol9T"};